import { TAB_KEY } from '@/shared/config';
import { KeyRecoilProps } from '@/shared/model';
import { TabBeatUIEffect } from '@/widgets/beats';
import { TabHRSummaryUIEffect } from '@/widgets/hr-summary';
import { TabECGEventUIEffect } from '@/widgets/ecg-events';
import { TabStripManagermentUIEffect } from '@/widgets/strips-management';

/**
 * Mounts the UI-side effect component belonging to the active report tab. Switches on the tab id to render the beat, ECG event, strip management or HR summary effect with the given store key, and renders nothing otherwise.
 *
 * @param keyRecoil - Store key identifying the report tab's slice of state.
 * @param tab - The active tab id selecting which effect to mount.
 * @returns The UI effect component for the tab, or null.
 */
const UIEffect = ({ keyRecoil, tab }: KeyRecoilProps & { tab: string }) => {
  switch (tab) {
    case TAB_KEY.BEATS:
      return <TabBeatUIEffect keyRecoil={keyRecoil} />;
    case TAB_KEY.ECG_EVENTS:
      return <TabECGEventUIEffect keyRecoil={keyRecoil} />;
    case TAB_KEY.STRIPS_MANAGEMENT:
      return <TabStripManagermentUIEffect keyRecoil={keyRecoil} />;
    case TAB_KEY.HR_SUMMARY:
      return <TabHRSummaryUIEffect keyRecoil={keyRecoil} />;
    default:
      return null;
  }
};

export default UIEffect;
